
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import MobileTabbar from "../components/MobileTabbar";

function AppShell({ children }) {
  const location = useLocation();
  const isLogin = location.pathname === "/";
  if (isLogin) return children;

  return (
    <div className="cc-shell">
      <Header />
      <MobileTabbar />
      <main className="cc-main">
        <div className="cc-mobile-top">
          <div className="cc-mobile-brand"><img src="/assets/ClinCash Logo Sin fondo.png" alt="" /><span>Clin<b>Cash</b></span></div>
          <input className="cc-mobile-search" placeholder="Buscar..." aria-label="Buscar clientes y créditos" />
          <div className="cc-avatar">EP</div>
        </div>
        <div className="cc-page">{children}</div>
      </main>
    </div>
  );
}

export default AppShell;
